exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label[data-v-7e2f1394]{font-weight:500;color:#495057}.enquiries-form__honeypot[data-v-7e2f1394]{position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden}.d-flex[data-v-7e2f1394]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:.75rem}.d-flex .btn[data-v-7e2f1394]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e2f1394","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Enquiries/EnquiriesForm.vue
// module id = 2371
// module chunks = 1